export default "__VITE_ASSET__CS212Nfs__"